import { getWindowSize, missingWidget } from '../utils/helpers';
import { updateLinksAttributes } from '../utils/handleAttributes';
const wrapContainerClass = 'exploreCards-container';
const breakpointMobile = 800;

function exploreCards() {
  const widgetName = 'exploreCards';
  const $widget = $(`#${widgetName}`);
  const widgetOpts = typeof exploreCardsOpts === 'undefined' ? null : exploreCardsOpts;

  if (!widgetOpts) {
    missingWidget(widgetName);
    return;
  }

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: getWindowSize(breakpointMobile) ? [''] : ['all'],
    showDescription: true,
    moreButton: true,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    textOverImage: true,
    maxItemsVisible: 6,
    itemsPerPanel: 1,
    buyNowButton: false,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomCards(data.items, $widget);
      } else {
        $(`.${wrapContainerClass}`).remove();
      }
    },
  });
}

function createCustomCards(widgetData, $widget) {
  $widget.find('.card-content').remove();

  $widget.find('.card-widget-item').each(function (x) {
    const { Title, URL } = widgetData[x];
    const $cardItem = $(this);

    if (URL == null || URL == undefined || (URL == '' && !$cardItem.hasClass('void-link'))) {
      $cardItem.addClass('void-link');
    }

    $cardItem.append(`
          <div class="card-content">
            <div class="widget-title-wrapper">
              <h3 class="widget-title">${Title}</h3>
            </div>
            <div class="hover-content">
            ${URL ? `<a href="${URL}" class="button alternative-btn" ${updateLinksAttributes(URL, Title)}>More</a>` : ''}
            </div>
          </div>`);

    if (!getWindowSize(breakpointMobile)) {
      updateLinksAttributes(URL, Title, $cardItem);
    }
  });
}

export default function updateCards() {
  let isMobile;

  function triggerFeature() {
    const matches = globalThis.matchMedia(`(max-width: ${breakpointMobile}px)`).matches;
    if (matches === isMobile) return;
    isMobile = matches;

    $(`.${wrapContainerClass} #exploreCards`).empty();
    exploreCards();
  }
  triggerFeature();

  $(globalThis).on('resize', triggerFeature);
}
